<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100;">
  @for (toast of toasts; track toast) {
    <ngb-toast [autohide]="true" [delay]="3000"
      class="mb-2" [class]="'text-white bg-' + toast.type">
      {{ toast.message }}
    </ngb-toast>
  }
</div>
@if (isSpinner) {
  <div class="spinner"><img src="../assets/loader.gif"></div>
}
<router-outlet />